/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 15:39:23                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-05 16:44:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * Styles
  * TopNavigationBar: top navigation bar
*/

/* Imports */
import { Typography} from "@material-tailwind/react";
import { Link } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import { useTranslation } from "react-i18next";
import { Bars3Icon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
/***/

/* Components */
import { ProfileMenu } from "./profile-menu/ProfileMenu";
import CountryIndicator from "../../country-indicator/CountryIndicator";
/***/ 

/* Styles */
import "./TopNavigationBar.scss";
import SearchBar from "../../searchbar/SearchBar";
/***/

/**
* TopNavigationBar: top navigation bar
* Contain the search bar, the admin button and the profile menu
*/
export function TopNavigationBar({
  className,
  notif,
  onMenuToggle
}: {
  className?: string,
  notif?: any,
  onMenuToggle?: () => void
}) {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
  }, []);

  return (
    <nav className="top-navbar">
      <div className="left-side">
        {/* Bouton hamburger pour mobile */}
        {isMobile && (
          <button 
            className="hamburger-btn"
            onClick={onMenuToggle}
            aria-label="Toggle navigation menu"
          >
            <Bars3Icon className="w-6 h-6 text-gray-700" />
          </button>
        )}
        
        <SearchBar />
      </div>

      <div className="right-side">
        <ul className="nav-list">
          {keycloak.realmAccess?.roles.includes("ROLE_SUPER_ADMIN") &&
            <Typography as="li" variant="small">
              <Link to="/admin">{t("common:administration")}</Link>
            </Typography>
          }

          {/* TODO: Créer la page de notification 
          <Typography as="li" variant="small">
            <a href="/notification">
              {notif ?
                <BellAlertIcon className="w-[24px]"/>
              : 
                <BellIcon className="w-[24px]"/>
              }
            </a>
          </Typography> */}
        </ul>

        <div className="profile">
          <ProfileMenu/>
        </div>
        
        <div className="separator"></div>
        
        <CountryIndicator />
      </div>
    </nav>
  );
}
/***/
